import { ReactElement } from "react";
import { useHistory } from "react-router-dom";
import styles from "./FullScreenWidgetHeader.module.scss";

interface IFullScreenWidgetHeaderProps
{
    title: string;
}

function FullScreenWidgetHeader(props: IFullScreenWidgetHeaderProps): ReactElement
{
    const history = useHistory();

    return (
        <div className={styles.header}>
            <h3>{props.title}</h3>
            <button className="btn btn-sm" onClick={history.goBack}>
                <i className="material-icons">arrow_back</i>
                <span>Back</span>
            </button>
        </div>
    )
}

export default FullScreenWidgetHeader;